import dayjs from 'dayjs';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import Day from './day';
dayjs.extend(isLeapYear);
export default class Month {
    constructor(date = null, lang = 'default') {
        const day = new Day(date, lang);
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        const monthSize = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        this.lang = lang;
        this.name = day.month;
        this.number = day.monthNumber;
        this.year = day.year;
        this.numberOfDays = monthSize[this.number - 1];
        if (this.number === 2) {
            this.numberOfDays += dayjs(day.date).isLeapYear() ? 1 : 0;
        }
    }
    getDay(date) {
        return new Day(new Date(this.year, this.number - 1, date), this.lang);
    }
}
